export default __webpack_public_path__ + "static/108-e7c3dc8d3ff010f189ee19c7a9299261.jpg";